import { DataBean } from "../DataBean";

export class Appointment extends DataBean {
  public async getAppointmentCatalog(): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAppointmentCatalog_Number",
      [null]
    );
  }

  public async getAppointment(idAppointment: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "admin.Appointment_getAppointment_Number",
      [idAppointment]
    );
  }

  public async getAppointmentCatalogByEmploymentBonus(
    idEmploymentBonus: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getAppointmentCatalogByEmploymentBonus_Number",
      [idEmploymentBonus]
    );
  }
}
